import { HobClearanceUI } from "./HobClearanceUI";
import { StandardProps } from "../componentMap";
import { getAttributeValues } from "../../utils/product/getAttributeValues";

export function HobClearance({ product }: Pick<StandardProps, "product">) {
  const hobClearanceValues = getAttributeValues(
    "minimumclearancedimensions",
    product.attributes ?? [],
  );
  return <HobClearanceUI hobClearance={hobClearanceValues[0] || ""} />;
}
